<oa-autocomplete [value]="value && value.code? value : null " [options]="autocompleteOptions" [api]="api"
  (changed)="onSelect($event)" [disabled]="disabled" [readonly]="readonly">
</oa-autocomplete>
